import { Card, Form, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import CustomTextInput from "../../../components/CustomTextInput";
import { educationLevelService } from "../../../services/education-level.service";

export default function EducationLevelForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data } = useGetDetailApi({
    id,
    serviceFn: educationLevelService.findById,
    queryKey: ["education-level"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: educationLevelService,
    form: form,
    messageApi: messageApi,
    queryKey: "education-level",
    route: "/master-data/education-level",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " Jenjang Pendidikan"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/education-level"}
            onClick={form.submit}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <CustomTextInput
            label="Nama Jenjang Pendidikan"
            name="name"
            rules={[
              { required: true, message: "Nama Jenjang Pendidikan harus diisi" },
            ]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
